import { Reveal } from "./Reveal";
import { BRAND_LOGOS } from "../constants/site";
import "./LogoTicker.css";

const TILES = BRAND_LOGOS.length
    ? BRAND_LOGOS
    : Array.from({ length: 6 }).map((_, i) => ({
          name: `[BRAND_LOGO_${i + 1}]`,
          url: null,
      }));

export const LogoTicker = () => {
    return (
        <section
            className="logo-ticker-section"
            data-testid="logo-ticker-section"
        >
            <div className="logo-ticker-inner">
                <Reveal
                    as="p"
                    className="eyebrow logo-ticker-label"
                    data-testid="logo-ticker-label"
                >
                    Creators and brands we have worked with
                </Reveal>
                <div className="logo-ticker" data-testid="logo-ticker">
                    <div className="logo-ticker-track">
                        {Array.from({ length: 4 }).flatMap((_, copy) =>
                            TILES.map((tile, i) =>
                                tile.url ? (
                                    <div
                                        className={`logo-tile${tile.light ? " logo-tile-light" : ""}`}
                                        key={`${copy}-${tile.name}`}
                                        data-testid={
                                            copy === 0
                                                ? `logo-tile-${i}`
                                                : undefined
                                        }
                                    >
                                        <img src={tile.url} alt={tile.name} />
                                    </div>
                                ) : (
                                    <div
                                        className="logo-tile"
                                        key={`${copy}-${tile.name}`}
                                        data-testid={
                                            copy === 0
                                                ? `logo-tile-${i}`
                                                : undefined
                                        }
                                    >
                                        <span className="logo-tile-placeholder">
                                            {tile.name}
                                        </span>
                                    </div>
                                ),
                            ),
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};
